import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=0278b505&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=ts"
export * from "./Offer.vue?vue&type=script&lang=ts"
import style0 from "./Offer.vue?vue&type=style&index=0&id=0278b505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0278b505",
  null
  
)

export default component.exports